import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import * as Anuto from "../../../engine/src";

export class Bot {

    public static play(index: number): {stars: number, lifes: number, credits: number, ticks: number, turrets: any, round: number} {

        let bestResult = {stars: -1, lifes: -1, credits: 0, ticks: 0, turrets: [], round: 0};

        for (let k = 0; k < 50; k++) {

            GameVars.enemiesPathsCells = GameVars.currentMapData.paths;
            GameVars.plateausCells = GameVars.currentMapData.plateaus;

            const gameConfig: Anuto.Types.GameConfig = {
                timeStep: GameConstants.TIME_STEP,
                runningInClientSide: false,
                initialTimer: false,
                enemySpawningDeltaTicks: GameConstants.ENEMY_SPAWNING_DELTA_TICKS,
                credits: GameVars.currentMapData.waves.initialCoins || GameConstants.INITIAL_CREDITS,
                lifes: GameConstants.INITIAL_LIFES,
                boardSize: GameVars.currentMapData.size,
                enemiesPathsCells : GameVars.enemiesPathsCells,
                plateausCells: GameVars.plateausCells,
                suicideAttackCooldownTicks: GameConstants.SUICIDE_ATTACK_COOLDOWN_TICKS,
                suicideAttackDamage: GameConstants.SUICIDE_ATTACK_DAMAGE,
                freezeAttackCooldownTicks: GameConstants.FREEZE_ATTACK_COOLDOWN_TICKS,
                freezeAttackDuration: GameConstants.FREEZE_ATTACK_DURATION
            };

            GameVars.wavesData = GameVars.currentMapData.waves.waves;

            let anutoEngine = new Anuto.Engine(gameConfig, GameVars.enemiesData, GameVars.turretsData, GameVars.wavesData, GameVars.modifiers);

            anutoEngine.addEventListener(Anuto.Event.WAVE_OVER, () => {
                // anutoEngine.newWave();
            }, this);

            let turrets = GameVars.gameData.levelsInfo[index].turrets;

            let cellsTurrets = [];
            for (let i = 0; i < GameVars.plateausCells.length; i++) {

                let turret = Bot.selectTurret(turrets);

                let cellTurret = {
                    p: GameVars.plateausCells[i],
                    type: turret.type,
                    added: false,
                    id: null,
                    level: 1,
                    levelMax: turret.levelMax
                };
                cellsTurrets.push(cellTurret);
            }

            let actions = [];

            if (GameVars.prevTurrets && GameVars.usePrevTurrets) {
                for (let i = 0; i < GameVars.prevTurrets.turrets.length; i++) {
        
                    let turretInfo = GameVars.prevTurrets.turrets[i];

                    let turret = anutoEngine.addTurret(turretInfo.type, turretInfo.p, true, turretInfo.level);

                    for (let j = 0; j < cellsTurrets.length; j++) {

                        if (cellsTurrets[i].p.c === turret.position.c && cellsTurrets[i].p.r === turret.position.r) {
                            cellsTurrets[i].added = true;
                            cellsTurrets[i].id = turret.id;
                            cellsTurrets[i].type = turret.type;
                            cellsTurrets[i].level = turret.level;
                            cellsTurrets[i].levelMax = turret.maxLevel;
                        }
                    }
                }
            }

            anutoEngine.newWave();

            while (!anutoEngine.gameOver && !anutoEngine.win) {

                // buscar si hay huecos para construir disponibles y montar torre si hay dinero disponible
                // si estan todos los huecos llenos, buscar que torretas se pueden mejorar

                cellsTurrets = cellsTurrets.sort(() => Math.random() - 0.5);
                for (let i = 0; i < cellsTurrets.length; i++) {
                    if (!cellsTurrets[i].added) {
                        let turret = anutoEngine.addTurret(cellsTurrets[i].type, cellsTurrets[i].p);
                        if (turret) {
                            cellsTurrets[i].added = true;
                            cellsTurrets[i].id = turret.id;
                            actions.push("ADD TURRET " + cellsTurrets[i].id + "(" + cellsTurrets[i].type + ") - " + anutoEngine.ticksCounter);
                            break;
                        }
                    } else {
                        if (cellsTurrets[i].level < cellsTurrets[i].levelMax) {
                            if (anutoEngine.upgradeTurret(cellsTurrets[i].id)) {
                                cellsTurrets[i].level++;
                                actions.push("UPGRADE TURRET " + cellsTurrets[i].id + " - " + anutoEngine.ticksCounter);
                            }
                        }
                    }
                }

                // lanzar ataques especiales en cuanto estan disponibles
                if (anutoEngine.enemies.length > 0) {
                    if (GameVars.gameData.levelsInfo[index].specials[0]) {
                        if (anutoEngine.launchSuicideAttack()) {
                            actions.push("SUICIDE ATTACK - " + anutoEngine.ticksCounter);
                        }
                    }

                    if (GameVars.gameData.levelsInfo[index].specials[1]) {
                        if (anutoEngine.launchFreezeAttack()) {
                            actions.push("FREEZE ATTACK - " + anutoEngine.ticksCounter);
                        }
                    }
                }
                
                anutoEngine.update();
            }

            if (anutoEngine.lifes > bestResult.lifes) {
                bestResult = {stars: Math.ceil((anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3), lifes: anutoEngine.lifes, credits: anutoEngine.credits, ticks: anutoEngine.ticksCounter, turrets: cellsTurrets, round: anutoEngine.round};
            } else if (anutoEngine.lifes === bestResult.lifes) {
                if (anutoEngine.round > bestResult.round) {
                    bestResult = {stars: Math.ceil((anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3), lifes: anutoEngine.lifes, credits: anutoEngine.credits, ticks: anutoEngine.ticksCounter, turrets: cellsTurrets, round: anutoEngine.round};
                } else if (anutoEngine.round === bestResult.round) {
                    if (anutoEngine.ticksCounter > bestResult.ticks) {
                        bestResult = {stars: Math.ceil((anutoEngine.lifes / GameConstants.INITIAL_LIFES) * 3), lifes: anutoEngine.lifes, credits: anutoEngine.credits, ticks: anutoEngine.ticksCounter, turrets: cellsTurrets, round: anutoEngine.round};
                    }
                }
            } 

            console.log("IT " + k + " DONE");
                    
        }

        return bestResult;
    }

    private static selectTurret(turrets: number[]): {type: string, levelMax: number} {

        let pos = [];

        for (let i = 0; i < turrets.length; i++) {
            if (turrets[i] > 0) {
                pos.push(i);
            }
        }

        let num = pos[Math.floor(Math.random() * pos.length)];

        switch (num) {
            case 0:
                return {type: Anuto.GameConstants.TURRET_PEA, levelMax: turrets[num]};
            case 1:
                return {type: Anuto.GameConstants.TURRET_MORTAR, levelMax: turrets[num]};
            case 2:
                return {type: Anuto.GameConstants.TURRET_SPLAT, levelMax: turrets[num]};
            case 3:
                return {type: Anuto.GameConstants.TURRET_BZZT, levelMax: turrets[num]};
            case 4:
                return {type: Anuto.GameConstants.TURRET_ROCKETS, levelMax: turrets[num]};
            case 5:
                return {type: Anuto.GameConstants.TURRET_MINES, levelMax: turrets[num]};
            case 6:
                return {type: Anuto.GameConstants.TURRET_FIRE, levelMax: turrets[num]};
            case 7:
                return {type: Anuto.GameConstants.TURRET_TELEPORT, levelMax: turrets[num]};
            default:
                break;
        }
    }
}